import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Remove+Shipping+Address+from+Profile+API

function removeShippingAddress(profileId, addressId) {
    let url = `/api/users/profiles/${profileId}/address/${addressId}`;
    const { enableProfileShippingGroup = false } = Sephora.configurationSettings;

    if (enableProfileShippingGroup && cookieUtils.isRCPShippingAPIEnabled()) {
        url = `/gway/v2/users/profiles/${profileId}/address/${addressId}`;
    }

    return ufeApi.makeRequest(url, { method: 'DELETE' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default removeShippingAddress;
